import Image from 'react-bootstrap/Image'

import TituloNegrito from './TituloNegrito'
import CardProdutoBea from './CardProdutoBEA'

import { retornarTexto } from '../helpers/textoHelper'

import aves from '../images/aves.png'
import bovinosLeite from '../images/bovinos-leite.png'
import bovinosCorte from '../images/bovinos-corte.png'
import bovinosCentrais from '../images/centrais.png'
import pescados from '../images/pescados.png'
import suinos from '../images/suinos.png'

function ProdutosCertificadosBEA({ produtos, exibirMenu, resolucaoMobile, idioma, slugEmpresa }) {

    let produtosPorEspecie = {
        'Avicultura': produtos.filter((produto) => produto['Avicultura']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
        'Bovinos - Centrais': produtos.filter((produto) => produto['Bovinos - Centrais']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
        'Bovinos de Corte': produtos.filter((produto) => produto['Bovinos de Corte']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
        'Bovinos de Leite': produtos.filter((produto) => produto['Bovinos de Leite']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
        'Pescados': produtos.filter((produto) => produto['Pescados']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
        'Suínos': produtos.filter((produto) => produto['Suínos']?.toUpperCase() === 'X' && produtoExisteNoIdiomaSelecionado(produto)),
    }

    const estiloTexto = { fontSize: '20px', color: 'white' }
    const estiloIcone = { height: '35px' }

    function produtoExisteNoIdiomaSelecionado(produto) {
        let exibirProduto = false

        if (idioma === 'pt') {
            exibirProduto = true
        } else if (idioma === 'en') {
            if (produto['Descrição do produto (Inglês)']) {
                exibirProduto = true
            }
        } else if (idioma === 'es') {
            if (produto['Descrição do produto (Espanhol)']) {
                exibirProduto = true
            }
        }

        return exibirProduto
    }

    function montarSecaoEspecie(titulo, especie, imagem) {
        return <div>
            <div style={{ gap: '10px' }} className='mt-5 d-flex align-items-center justify-content-center'>
                <Image style={estiloIcone} src={imagem} alt='logo' fluid />
                <span style={estiloTexto}>{titulo}</span>
            </div>
            <div style={{ gap: '20px' }} className='mb-2 mt-5 d-flex flex-wrap align-items-center justify-content-center'>
                {produtosPorEspecie[`${especie}`]?.map((produto) => <CardProdutoBea key={produto['Nome do produto/serviço']} exibirMenu={exibirMenu} produto={produto} resolucaoMobile={resolucaoMobile} idioma={idioma} slugEmpresa={slugEmpresa} />)}
            </div>
        </div>
    }

    return (
        <>
            <TituloNegrito texto={retornarTexto(idioma, 'produtosCertificados')} />
            <div style={{ width: '80vw' }} className='mb-2 d-flex flex-column align-items-center justify-content-center'>

                {/* Avicultura */}
                {produtosPorEspecie?.Avicultura?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Poultry' : idioma === 'es' ? 'Avicultura' : 'Avicultura', 'Avicultura', aves) : <></>}

                {/* Bovinos - Centrais */}
                {produtosPorEspecie['Bovinos - Centrais']?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Cattle - Central' : idioma === 'es' ? 'Ganado - Central' : 'Bovinos - Centrais', 'Bovinos - Centrais', bovinosCentrais) : <></>}

                {/* Bovinos de Corte */}
                {produtosPorEspecie['Bovinos de Corte']?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Beef cattle' : idioma === 'es' ? 'Ganado vacuno' : 'Bovinos de Corte', 'Bovinos de Corte', bovinosCorte) : <></>}

                {/* Bovinos de Leite */}
                {produtosPorEspecie['Bovinos de Leite']?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Dairy cattle' : idioma === 'es' ? 'Vacas lecheras' : 'Bovinos de Leite', 'Bovinos de Leite', bovinosLeite) : <></>}

                {/* Pescados */}
                {produtosPorEspecie?.Pescados?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Fish' : idioma === 'es' ? 'Pescados' : 'Pescados', 'Pescados', pescados) : <></>}

                {/* Suínos */}
                {produtosPorEspecie?.Suínos?.length > 0 ? montarSecaoEspecie(idioma === 'en' ? 'Swine' : idioma === 'es' ? 'Cerdos' : 'Suínos', 'Suínos', suinos) : <></>}

            </div>
        </>
    );
}
export default ProdutosCertificadosBEA;
